<template lang="pug">
  .part.part-4
    .game__title
      p 化身創作人的你
    .game__form
      .game__form__row
        .game__form__header
          p 暱稱#[br]#[span 請輸入6字內中英文]
        .game__form__content(:class="{'game__form__content--no-data': !nickname && !nicknameFocused}")
          textarea.game__form__textarea(
            :class="{'game__form__textarea--two-rows': isNicknameTwoRows}"
            maxlength="6"
            v-model="nickname"
            @keypress="checkNickname"
            @keyup="checkNickname"
            @keydown="checkNickname"
            @change="checkNickname"
            @focus="nicknameFocused = true"
            @blur="nicknameFocused = false"
            ref="textarea"
          )
          //- p {{ nickname }}
      .game__form__row
        .game__form__header
          p 年齡#[br]#[span &nbsp;]
        .game__form__content(:class="{'game__form__content--no-data': !age && !ageFocused}")
          input(
            type="text"
            inputmode="numeric"
            maxlength="2"
            v-model="age"
            @focus="ageFocused = true"
            @blur="ageFocused = false"
          )
    a.game__button.game__button--next(href="#" @click.prevent="checkForm")
      span 下一步
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { tabooWords } from '@/json/tabooWords.json'

export default {
  name: 'GamePart4',
  props: {
    changePart: Function,
  },
  watch: {
    nickname() {
      this.checkNickname();
    },
  },
  data: () => {
    return {
      nickname: null,
      age: null,
      nicknameFocused: false,
      ageFocused: false,
      isNicknameTwoRows: false,
      defaultTextareaHeight: 0,
    }
  },
  computed: {
    ...mapState(['author'])
  },
  methods: {
    ...mapActions(['saveAuthor']),
    checkForm() {
      const { author, nickname, age, saveAuthor } = this;
      const nicknameRegex = /[\u4e00-\u9fa5A-Za-z]/g;
      const numberRegex = /[\d+]/g;
      if (!nickname) {
        // this.$toast.error('請輸入暱稱');
        this.$toast.error('請輸入 6 字內中英文，請勿使用不雅或敏感字詞');
        return;
      }
      if (nickname.length > 6) {
        // this.$toast.error('請輸入六個字內的中英文字');
        this.$toast.error('請輸入 6 字內中英文，請勿使用不雅或敏感字詞');
        return;
      }
      if (numberRegex.test(nickname)) {
        // this.$toast.error('暱稱僅限輸入中英文字');
        this.$toast.error('請輸入 6 字內中英文，請勿使用不雅或敏感字詞');
        return;
      }
      if (!nicknameRegex.test(nickname)) {
        // this.$toast.error('暱稱僅限輸入中英文字');
        this.$toast.error('請輸入 6 字內中英文，請勿使用不雅或敏感字詞');
        return;
      }
      for (let i = 0; i < tabooWords.length; i++) {
        if (nickname.indexOf(tabooWords[i]) !== -1) {
          // this.$toast.error('請勿輸入髒話或敏感字詞');
          this.$toast.error('請輸入 6 字內中英文，請勿使用不雅或敏感字詞');
          return;
        }
      }
      if (!age) {
        // this.$toast.error('請輸入年齡');
        this.$toast.error('請輸入 1 ~ 99 的年齡數字');
        return;
      }
      if (age >= 100) {
        // this.$toast.error('請輸入有效的年齡範圍');
        this.$toast.error('請輸入 1 ~ 99 的年齡數字');
        return;
      }
      saveAuthor({ ...author, nickname, age });
      this.changePart(5);
      this.$trackEvent('step2', 'click_button', 'step2_next');
    },
    checkNickname() {
      const { replaceLineBreak, setTextareaHeight } = this;
      replaceLineBreak();
      setTextareaHeight();
    },
    replaceLineBreak() {
      if (!this.nickname) return;
      const { nickname } = this;
      this.nickname = nickname.replace(/(?:\r\n|\r|\n)/g, '');
    },
    initTextareaHeight() {
      const { textarea } = this.$refs;
      this.defaultTextareaHeight = textarea.clientHeight;
    },
    setTextareaHeight() {
      const { defaultTextareaHeight } = this;
      const { textarea } = this.$refs;
      this.isNicknameTwoRows = false;
      this.$nextTick(() => {
        this.isNicknameTwoRows = (defaultTextareaHeight < textarea.scrollHeight);
      })
    },
  },
  mounted() {
    const { initTextareaHeight, checkNickname } = this;
    initTextareaHeight();
    checkNickname();
    this.$trackPage('step2');
  },
  components: {
  }
}
</script>

<style lang="scss">

$assets: '~@/assets/images/game/part-4/';

#game .part-4 {

  .game__title {
    position: absolute;
    top: vw(585);
    left: 0;
    width: 100%;
    p {
      font-size: vw(30);
      text-align: center;
      line-height: 1;
      letter-spacing: vw(letterSpacing(500, 30));
      padding-left: vw(letterSpacing(500, 30));
      @include narrow-text;
      @include neon-text;
    }
  }

  .game__form {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: vw(665);
    left: 0;
    width: 100%;
  }

  .game__form__row {
    position: relative;
    width: vw(204);
    height: vw(296);
    margin: 0 vw(16);
    border: #fff vw(1) solid;
    box-shadow: rgba(#fff, 0.85) inset 0 0 vw(100), rgba(#ff47bc, 0.5) 0 0 vw(15), rgba(#ff47bc, 0.2) 0 0 vw(50);
    border-radius: vw(10);
  }

  .game__form__header {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 0 vw(30) vw(20);
    p {
      font-size: vw(26);
      text-align: left;
      line-height: 1;
      letter-spacing: vw(letterSpacing(500, 26));
      @include narrow-text;
      @include neon-text;
      transform-origin: left top;
    }
    span {
      font-size: vw(14);
      letter-spacing: vw(letterSpacing(340, 14));
      white-space: nowrap;
    }
  }

  .game__form__content {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    // padding-bottom: vw(48);
    textarea, input {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: calc(100% - vw(32));
      color: #fff;
      font-size: vw(30);
      text-align: center;
      line-height: 1;
      letter-spacing: vw(letterSpacing(220, 30));
      text-indent: vw(letterSpacing(220, 30));
      margin: 0 auto;
      background: none;
      transform: scaleX(0.9);
      // caret-color: transparent;
    }
    textarea {
      // opacity: 0;
      position: static;
      height: 1.5em;
      line-height: 1.5;
      text-indent: 0;
      margin-bottom: vw(26);
      padding: 0 vw(letterSpacing(220, 30)) 0 vw(letterSpacing(220, 30) * 2);
      overflow: hidden;
      &.game__form__textarea--two-rows {
        height: 3em;
      }
    }
  }

  .game__form__content--no-data::before {
    content: '';
    position: absolute;
    top: vw(134);
    left: 50%;
    width: vw(2);
    height: vw(34);
    transform: translate(-50%, -50%);
    background: #fff;
    animation: inputCaret 1.5s ease infinite;
  }

  @keyframes inputCaret {
    0%, 100% {
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
  }

  .game__button--next {
    top: vw(1018);
    left: vw(156);
  }

}

</style>
